import { render, staticRenderFns } from "./behaviorAddDialog.vue?vue&type=template&id=13121fa2&scoped=true"
import script from "./behaviorAddDialog.vue?vue&type=script&lang=js"
export * from "./behaviorAddDialog.vue?vue&type=script&lang=js"
import style0 from "./behaviorAddDialog.vue?vue&type=style&index=0&id=13121fa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13121fa2",
  null
  
)

export default component.exports